import type { I18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import { ApiError } from "./ApiError";
import type { ApiErrorBody } from "./apiErrorCodes";
import { apiErrorMessages } from "./apiErrorMessages";

// Сужение union по `error` не доходит до индекса в `apiErrorMessages`, поэтому вызов —
// через функцию с общим типом. Пара «код — params» гарантирована `ApiErrorBody`.
const translate = (body: ApiErrorBody, i18n: I18n): string => {
  const format = apiErrorMessages[body.error] as (
    params: ApiErrorBody["params"],
    i18n: I18n,
  ) => string;
  return format(body.params, i18n);
};

// Текст ошибки для пользователя на текущем языке.
// Код из контракта — его перевод; неизвестный код — общее сообщение (код уже ушёл в Sentry);
// не `ApiError` (обрыв сети, `TypeError` из `fetch`) — сообщение о связи.
export const getApiErrorMessage = (error: unknown, i18n: I18n): string => {
  if (!(error instanceof ApiError)) {
    return i18n._(
      msg({
        id: "errors.network",
        message: "No connection to the server. Check your internet and try again.",
      }),
    );
  }
  if (error.body === null) {
    return i18n._(msg({ id: "errors.unknown", message: "Something went wrong. Try again later." }));
  }
  return translate(error.body, i18n);
};
